import React, { useEffect, useState } from 'react';
import styles from './styles/survey.module.css';
import DeviceVerificationResults from './components/DeviceVerificationResults';
import FirstQuestion from './components/FirstQuestion';
import SecondQuestion from './components/SecondQuestion';
import SurveyFeatures from './components/SurveyFeatures';
import logo from '../../assets/images/DtpLogoSmall.webp';
import { useLocation } from "react-router-dom";
import data from './data/secondSlide.json';
import ProgressBar from './components/ProgressBar';
const userAnswers = [];

const Survey = () => {

    const [surveyIndex, setSurveyIndex] = useState(-1);
    const [startSurvey, setStartSurvey] = useState(false);
    const [userData, setUserData] = useState('');
    const [dataId, setDataId] = useState('');
    const [isSurveyEnded, setIsSurveyEnded] = useState(false);
    const surveyData = data.secondSlide;
    const [questionTitle, setQuestionTitle] = useState('');
    const [answers, setAnswers] = useState([]);
    const [questionIndex, setQuestionIndex] = useState(1);
    const location = useLocation();




    const switchQuestion = (id, answer) => {
        if (surveyIndex === -1) {
            setDataId(id);
        }
        setSurveyIndex(surveyIndex + 1);
        setQuestionIndex(questionIndex + 1);
        if (surveyIndex >= 0) {
            userAnswers[surveyIndex] = answer;
        }
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        if (surveyIndex < 4) {
            window.dataLayer.push({
                event: 'surveyResults',
                eventProps: {
                    questionLabel: id,
                    answers: userAnswers,
                }
            });
        }
    }


    useEffect(() => {
        let deviceData = location.state.data;
        if (!deviceData) {
            setStartSurvey(true);
        }
        setUserData(deviceData);
        localStorage.removeItem("afterPaymentSurveyFlag");
    }, [dataId, location.state.data]);

    useEffect(() => {
        let questionsArray = [];
        if (dataId) {
            questionsArray = surveyData.filter((item) => item.id === dataId);
        }
        if (surveyIndex < questionsArray[0]?.questions.length) {
            setQuestionTitle(questionsArray[0]?.questions[surveyIndex].title);
            setAnswers(questionsArray[0]?.questions[surveyIndex].answers);
        }
        if (surveyIndex > questionsArray[0]?.questions.length - 1) {
            setIsSurveyEnded(true);
        }
    }, [dataId, surveyData, surveyIndex]);




    return (
        <div className={styles.mainContainer}>
            <nav className={styles.navMainContainer}>
                <div className={styles.maxWidth}>
                    <a href="/"><img src={logo} alt="logo" className={styles.logo} /></a>
                </div>
                <div style={{ marginBottom: '-5px' }}>
                    <ProgressBar questionIndex={questionIndex} />
                </div>

            </nav>


            {!startSurvey ?
                <DeviceVerificationResults data={userData} />
                :
                <div className={styles.surveyContainer}>
                    {!isSurveyEnded ?
                        <>
                            {surveyIndex === -1 ? <FirstQuestion onQuestionPress={switchQuestion} /> :
                                <SecondQuestion dataId={dataId} onQuestionPress={switchQuestion} questionTitle={questionTitle} answers={answers} />
                            }
                        </> :

                        <SurveyFeatures dataId={dataId} />
                    }
                </div>
            }
        </div>
    )
}

export default Survey;